import React from 'react'
import { ReactComponent as ProfileIcon} from '../../../images/icons/googleColor.svg'
import ApiUrl from '../../../configTools/apiUrls';
import { useGoogleLogin } from '@react-oauth/google'

const Google = () => {

    const googleCallBack = useGoogleLogin({
        clientId: window.location.hostname === 'localhost'? '1004160975061-b6j28jthhreag81qdbrtn6fpm7bc38d9.apps.googleusercontent.com' :'276540982595-5neo5h285l4c5gngd2himi24c1j35lce.apps.googleusercontent.com',
        onSuccess: async responce =>  {
            console.log(responce);
            if(responce.access_token){
                let res = await fetch(ApiUrl.API_URL_OAuth+"/google", {//"http://localhost:5157/api/oauth/google",{//ApiUrl.API_URL_OAuth+"/google", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        token: responce.access_token
                    })
                })
                res = await res.json();
                console.log(res)
                if(res.success){
                    localStorage.setItem("user-info",JSON.stringify(res.responce));
                    document.location.reload();
                }
                else{
                    alert(res.responce)
                }
            }
        }
    });
  return (
    <div className='v2_public_login_mobile_form_social_google'>
        <button onClick={googleCallBack}><ProfileIcon/></button>
    </div>
  )
}

export default Google
